<script lang="ts" setup>
import type { EditorialSlideShowGalleryNew } from '@integration-layer/ampliance/schemas/editorial-slide-show-gallery-new-schema.localized'
import type { EditorialGallerySlideshowProps } from '@design-system/components/Editorial/EditorialGallerySlideshow.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialSlideShowGalleryNew
}>()

const data = await useComponentResponse<EditorialSlideShowGalleryNew>(props)
</script>

<template>
  <EditorialGallerySlideshow
    v-if="data"
    v-bind="data as unknown as EditorialGallerySlideshowProps"
  />
</template>
